<ng-form #form="ngForm">
    <account-edit-form-layout [source]="this"
                              [sectionTitle]="'Password' | translate"
                              [inFormTitle]="'Edit password' | translate">

        <!--Password-->
        <input-wrap>
            <view-password>
                <input class="input"
                       type="password"
                       name="currentPassword"
                       autocomplete="off"
                       reverse="true"
                       [(ngModel)]="data.currentPassword"
                       [muiInput]="('Current Password'| translate)"
                       required>
            </view-password>
        </input-wrap>

        <!--Password-->
        <input-wrap class="m-t-6 m-t-9-s m-t-9-m block">
            <view-password>
                <input class="input"
                       type="password"
                       name="password"
                       autocomplete="new-password"
                       [(ngModel)]="data.password"
                       [muiInput]="('New password'| translate)"
                       required>
            </view-password>
        </input-wrap>

        <!--Password confirmation-->
        <input-wrap class="m-t-6 m-t-9-s m-t-9-m block">
            <view-password>
                <input class="input"
                       type="password"
                       name="confirmPassword"
                       [(ngModel)]="data.confirmPassword"
                       [muiInput]="('Confirm new password'| translate)"
                       matchCheck="password"
                       required>
            </view-password>
        </input-wrap>

    </account-edit-form-layout>
</ng-form>
